module.exports = __webpack_public_path__ + "static/media/quickpak.d3d90181.jpg";